import { render, staticRenderFns } from "./popup.vue?vue&type=template&id=1856cf90&"
import script from "./popup.vue?vue&type=script&lang=js&"
export * from "./popup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1856cf90')) {
      api.createRecord('1856cf90', component.options)
    } else {
      api.reload('1856cf90', component.options)
    }
    module.hot.accept("./popup.vue?vue&type=template&id=1856cf90&", function () {
      api.rerender('1856cf90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/popup.vue"
export default component.exports